import { LegalPage } from "./LegalPage";

const SECTIONS = [
  {
    title: "Vad är cookies?",
    text: "Cookies är små textfiler som sparas i din webbläsare. De kan användas för allt från att få en sida att fungera till att spåra besökare för marknadsföring.",
  },
  {
    title: "Inga spårningscookies",
    text: "Den här webbplatsen använder inga spårningscookies, inga annonsnätverk och ingen profilering. Vi samlar inte in några onödiga uppgifter om dig.",
  },
  {
    title: "Nödvändig lagring",
    text: "Det enda som sparas är ditt val i samtyckesbannern, som lagras lokalt i din webbläsare (localStorage) så att du slipper svara igen vid nästa besök.",
  },
  {
    title: "Valfri anonym besöksstatistik",
    text: "Om du väljer att godkänna statistik räknar vi anonyma sidvisningar för att förstå hur sidan används. Det sker helt utan IP-adress, utan cookies och utan personuppgifter – vi ser bara att en sida visats, aldrig vem som sett den.",
  },
  {
    title: "Återkalla ditt samtycke",
    text: "Du kan när som helst återkalla eller ändra ditt val genom att rensa webbläsarens lokala lagring för den här sidan. Då visas bannern igen vid nästa besök. Frågor? Maila kontakt@studentflyttarna.se.",
  },
];

export default function CookiePolicy() {
  return <LegalPage testid="cookies-page" eyebrow="Juridik" title="Cookiepolicy" updated="september 2026" sections={SECTIONS} />;
}
